export default {
    pageErrorWarning: "Please resolve all of the errors on this page before moving to the next step.",
};
